// removed by extract-text-webpack-plugin
module.exports = {"authorization":"Authorization__authorization","title":"Authorization__title","providerLogo":"Authorization__providerLogo","message":"Authorization__message","startDayTrial":"Authorization__startDayTrial","startDayTrialMessage":"Authorization__startDayTrialMessage","or":"Authorization__or","authorizeNow":"Authorization__authorizeNow","changeProvider":"Authorization__changeProvider","growDotQello":"Authorization__growDotQello","growDotBlue":"Authorization__growDotBlue","growDotGolden":"Authorization__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Authorization/Authorization.scss
// module id = 1891
// module chunks = 0